import ContentBlockHeading from './ContentBlockHeading'
import ContentBlockParagraph from './ContentBlockParagraph'
import CTAHeadline from './CTAHeadline'
import CTAParagraph from './CTAParagraph'
import PrimaryHeading from './PrimaryHeading'
import PrimaryParagraph from './PrimaryParagraph'
import SecondaryHeading from './SecondaryHeading'

export {
  ContentBlockHeading,
  ContentBlockParagraph,
  CTAHeadline,
  CTAParagraph,
  PrimaryHeading,
  PrimaryParagraph,
  SecondaryHeading,
}
